export const emptyData = {
  model: {},
  baseSpec: {},
  pictures: {},
  offers: {},
  other: [],
  specifications: [],
  accessories: [],
  reviewsData: {},
  questions: {},
  linkedModels: [],
};

export const emptyModelData = {
  model: {},
  baseSpec: {
    show_description_in_modelcard: false,
    show_presets_anchor_in_modelcard: false,
    specifications: [],
  },
  offers: [],
  accessories: [],
  reviewsData: {},
  questions: {},
  navSections: [],
  popularOffer: null,
  active: '',
};
